import { App } from "vue";
import { vFold } from "./textFold";

export default (app: App) => {
  app.directive("fold", vFold);
};
